'use strict';

export default {
	IMPORT_TITLE: 'Import CSV Import',
	PICK_CSV: 'Pick CSV',
	UPLOAD: 'Upload',
	ERROR: 'Something went wrong - is the file formatted correctly?',
	SUCCESS: 'CSV Imported'
};